import { actionUpdateWorkspace } from "../../redux/actions/workspaceAction";
import { actionSetWorkpsace } from "../../redux/actions/UserAction";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BarChart2, Users } from "lucide-react";
import Popover from "@mui/material/Popover";
import { useState } from "react";
import { useSnackbar } from "notistack";
import Modal from "../Views/Modal";

const CardWorkSpace = ({ workspace, isSelected, isAdmin }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [updateVisibility, setUpdateVisibility] = useState(false);
  const token = useSelector((state) => state.user.token);
  const isUpdate = useSelector((state) => state.workspaces.isUpdateWorkspace);

  const [id, setId] = useState(null);
  const [name, setName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const dashboards = workspace.dashboards;
  const teams = workspace.teams;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const tag = open ? `simple-popover${name}` : undefined;

  const updateWorkspace = (e) => {
    e.preventDefault();
    if (name.trim() !== "" && id) {
      dispatch(
        actionUpdateWorkspace(id, name.trim(), token, ({ status, message }) => {
          if (status) {
            setUpdateVisibility(false);
            enqueueSnackbar(message || "", {
              variant: "success",
            });
            setName("");
            setId(null);
          } else {
            enqueueSnackbar(message || "", {
              variant: "warning",
            });
          }
        })
      );
    }
  };

  const confirmDelete = () => {};

  const deleteWorkspace = () => {};
  return (
    <>
      <Modal
        visible={updateVisibility}
        title={"Modifier l'espace de travail"}
        onCancel={
          isUpdate
            ? null
            : () => {
                setUpdateVisibility(false);
                setName("");
                setId(null);
              }
        }
        width={500}
      >
        <div className="flex flex-col w-full h-full gap-1 p-0 m-0">
          <form onSubmit={updateWorkspace}>
            <div className="flex flex-col w-full h-full gap-1 p-0 m-0">
              <div className="flex flex-col gap-2">
                <label for="nom" className="font-poppins font-[400px]">
                  Entrer le nom *
                </label>

                <input
                  className="w-full p-2 border-2 rounded-md outline-none border-inputBorderColor hover:outline-none active:outline-none"
                  name="nom"
                  id="nom"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Obligatoire"
                  required
                />
              </div>

              <div className="flex items-center justify-center gap-4 mt-2">
                <button
                  className="btn-border close-btn-submit"
                  type="reset"
                  onClick={isUpdate ? null : () => setUpdateVisibility(false)}
                >
                  Annuler
                </button>
                <button className="btn-full" type="submit" disabled={isUpdate}>
                  {isUpdate ? "Modifier..." : "+ Modifier"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </Modal>
      <div
        key={workspace.id}
        className={`relative flex p-3 py-2 pb-1 transition-shadow bg-white rounded-lg shadow-sm cursor-pointer  w-[350px] group hover:shadow-md ${
          isSelected ? "border-2 border-colorText" : ""
        } `}
        onClick={async () => {
          dispatch(actionSetWorkpsace(workspace.id));
          localStorage.setItem("idworkspace", workspace.id);
          navigate("/home");
        }}
        // onDoubleClick={async () => {}}
      >
        <div className="w-full">
          <div className="flex items-center gap-2 pb-2">
            <div
              style={{ backgroundColor: workspace.color }}
              className="flex items-center justify-center w-10 h-10  text-white rounded-md text-[25px] font-[600] font-poppins"
            >
              {workspace.name[0].toUpperCase()}
            </div>
            <div className="flex-1 font-poppins font-[600] text-[20px]">
              {workspace.name}
            </div>
            {/* {roleCompany !== "VISITOR" && ( */}
            {/*  */}
          </div>
          <div className="flex items-center px-2 justify-between h-[50px]  bg-customBg w-full   py-9 rounded-[8px]">
            <div className="flex flex-col items-center gap-2">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill={
                  // ? "#FFFFFF"
                  "#54555E"
                }
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0.104248 17.8541V16.2916H19.8959V17.8541H0.104248ZM1.14591 14.8491V8.47908H3.75008V14.8491H1.14591ZM6.17404 14.8491V3.27075H8.77821V14.8491H6.17404ZM11.2121 14.8491V6.39575H13.8162V14.8491H11.2121ZM16.2501 14.8491V0.145752H18.8543V14.8491H16.2501Z" />
              </svg>
              <div className="text-sm">
                <span className="font-poppins">{dashboards}</span> Dashboard
                {dashboards > 1 ? "s" : ""}
              </div>
            </div>
            {/* <div className="flex flex-col items-center gap-2">
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill={"#54555E"}
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M8.052 17.9478H11.6978V14.302H8.052V17.9478ZM14.302 17.9478H17.9478V14.302H14.302V17.9478ZM8.052 11.6978H11.6978V8.052H8.052V11.6978ZM14.302 11.6978H17.9478V8.052H14.302V11.6978ZM6.02882 21.8541C5.50261 21.8541 5.05721 21.6718 4.69263 21.3072C4.32804 20.9426 4.14575 20.4972 4.14575 19.971V6.02882C4.14575 5.50261 4.32804 5.05721 4.69263 4.69263C5.05721 4.32804 5.50261 4.14575 6.02882 4.14575H19.971C20.4972 4.14575 20.9426 4.32804 21.3072 4.69263C21.6718 5.05721 21.8541 5.50261 21.8541 6.02882V19.971C21.8541 20.4972 21.6718 20.9426 21.3072 21.3072C20.9426 21.6718 20.4972 21.8541 19.971 21.8541H6.02882ZM6.02882 20.2916H19.971C20.0512 20.2916 20.1247 20.2582 20.1913 20.1913C20.2582 20.1247 20.2916 20.0512 20.2916 19.971V6.02882C20.2916 5.94862 20.2582 5.87518 20.1913 5.80851C20.1247 5.74167 20.0512 5.70825 19.971 5.70825H6.02882C5.94862 5.70825 5.87518 5.74167 5.80851 5.80851C5.74167 5.87518 5.70825 5.94862 5.70825 6.02882V19.971C5.70825 20.0512 5.74167 20.1247 5.80851 20.1913C5.87518 20.2582 5.94862 20.2916 6.02882 20.2916Z" />
                        </svg>

                        <div className="text-sm">
                          <span className="font-poppins text-[15px] ">
                            {datasources}
                          </span>
                           Datasource{teams > 1 ? "s" : ""} 
                        </div>
                      </div> */}
            <div className="flex flex-col items-center gap-2">
              <Users className="w-5 h-5 text-[#54555E]" />

              <div className="text-sm">
                <span className="font-poppins text-[15px] ">{teams}</span>{" "}
                Equipe
                {teams > 1 ? "s" : ""}
              </div>
            </div>
            {/* <div className="flex flex-col items-center gap-2">
                        <svg
                          width="23"
                          height="22"
                          viewBox="0 0 23 22"
                          xmlns="http://www.w3.org/2000/svg"
                          fill={"#54555E"}
                        >
                          <path d="M2.30775 19.5C1.80258 19.5 1.375 19.325 1.025 18.975C0.675 18.625 0.5 18.1974 0.5 17.6923V4.30777C0.5 3.8026 0.675 3.37502 1.025 3.02502C1.375 2.67502 1.80258 2.50002 2.30775 2.50002H3.69225V0.384766H5.23075V2.50002H12.8077V0.384766H14.3077V2.50002H15.6923C16.1974 2.50002 16.625 2.67502 16.975 3.02502C17.325 3.37502 17.5 3.8026 17.5 4.30777V17.6923C17.5 18.1974 17.325 18.625 16.975 18.975C16.625 19.325 16.1974 19.5 15.6923 19.5H2.30775ZM2.30775 18H15.6923C15.7692 18 15.8398 17.9679 15.9038 17.9038C15.9679 17.8398 16 17.7693 16 17.6923V8.30777H2V17.6923C2 17.7693 2.03208 17.8398 2.09625 17.9038C2.16025 17.9679 2.23075 18 2.30775 18ZM2 6.80777H16V4.30777C16 4.23077 15.9679 4.16026 15.9038 4.09626C15.8398 4.0321 15.7692 4.00002 15.6923 4.00002H2.30775C2.23075 4.00002 2.16025 4.0321 2.09625 4.09626C2.03208 4.16026 2 4.23077 2 4.30777V6.80777ZM9 12.077C8.75517 12.077 8.5465 11.9908 8.374 11.8183C8.20167 11.6459 8.1155 11.4373 8.1155 11.1923C8.1155 10.9474 8.20167 10.7388 8.374 10.5663C8.5465 10.3939 8.75517 10.3078 9 10.3078C9.24483 10.3078 9.4535 10.3939 9.626 10.5663C9.79833 10.7388 9.8845 10.9474 9.8845 11.1923C9.8845 11.4373 9.79833 11.6459 9.626 11.8183C9.4535 11.9908 9.24483 12.077 9 12.077ZM5 12.077C4.75517 12.077 4.5465 11.9908 4.374 11.8183C4.20167 11.6459 4.1155 11.4373 4.1155 11.1923C4.1155 10.9474 4.20167 10.7388 4.374 10.5663C4.5465 10.3939 4.75517 10.3078 5 10.3078C5.24483 10.3078 5.4535 10.3939 5.626 10.5663C5.79833 10.7388 5.8845 10.9474 5.8845 11.1923C5.8845 11.4373 5.79833 11.6459 5.626 11.8183C5.4535 11.9908 5.24483 12.077 5 12.077ZM13 12.077C12.7552 12.077 12.5465 11.9908 12.374 11.8183C12.2017 11.6459 12.1155 11.4373 12.1155 11.1923C12.1155 10.9474 12.2017 10.7388 12.374 10.5663C12.5465 10.3939 12.7552 10.3078 13 10.3078C13.2448 10.3078 13.4535 10.3939 13.626 10.5663C13.7983 10.7388 13.8845 10.9474 13.8845 11.1923C13.8845 11.4373 13.7983 11.6459 13.626 11.8183C13.4535 11.9908 13.2448 12.077 13 12.077ZM9 16C8.75517 16 8.5465 15.9138 8.374 15.7413C8.20167 15.5689 8.1155 15.3603 8.1155 15.1155C8.1155 14.8705 8.20167 14.6618 8.374 14.4895C8.5465 14.317 8.75517 14.2308 9 14.2308C9.24483 14.2308 9.4535 14.317 9.626 14.4895C9.79833 14.6618 9.8845 14.8705 9.8845 15.1155C9.8845 15.3603 9.79833 15.5689 9.626 15.7413C9.4535 15.9138 9.24483 16 9 16ZM5 16C4.75517 16 4.5465 15.9138 4.374 15.7413C4.20167 15.5689 4.1155 15.3603 4.1155 15.1155C4.1155 14.8705 4.20167 14.6618 4.374 14.4895C4.5465 14.317 4.75517 14.2308 5 14.2308C5.24483 14.2308 5.4535 14.317 5.626 14.4895C5.79833 14.6618 5.8845 14.8705 5.8845 15.1155C5.8845 15.3603 5.79833 15.5689 5.626 15.7413C5.4535 15.9138 5.24483 16 5 16ZM13 16C12.7552 16 12.5465 15.9138 12.374 15.7413C12.2017 15.5689 12.1155 15.3603 12.1155 15.1155C12.1155 14.8705 12.2017 14.6618 12.374 14.4895C12.5465 14.317 12.7552 14.2308 13 14.2308C13.2448 14.2308 13.4535 14.317 13.626 14.4895C13.7983 14.6618 13.8845 14.8705 13.8845 15.1155C13.8845 15.3603 13.7983 15.5689 13.626 15.7413C13.4535 15.9138 13.2448 16 13 16Z" />
                        </svg>

                        <div className="text-sm">
                          <span className="font-poppins text-[15px] ">
                            {periodes}
                          </span>{" "}
                          Periode{teams > 1 ? "s" : ""}
                        </div>
                      </div> */}
          </div>
        </div>
      </div>
    </>
  );
};
export default CardWorkSpace;
